import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ 
  current = 0, 
  total = 100, 
  percentage = null,
  variant = 'default',
  size = 'md',
  showPercentage = true,
  showLabel = true,
  label = null,
  className = '',
  ...props 
}) => {
  // Calculate percentage if not provided
  const calculatedPercentage = percentage !== null ? percentage : Math.round((current / total) * 100);
  
  // Generate label if not provided
  const displayLabel = label || `${current} of ${total}`;
  
  // Base classes
  const baseClasses = 'progress-bar';
  const variantClasses = `progress-bar--${variant}`;
  const sizeClasses = `progress-bar--${size}`;
  
  return (
    <div 
      className={`${baseClasses} ${variantClasses} ${sizeClasses} ${className}`}
      {...props}
    >
      {/* Label and Percentage */}
      {showLabel && (
        <div className="progress-bar__header">
          <span className="progress-bar__label">{displayLabel}</span>
          {showPercentage && (
            <span className="progress-bar__percentage">{calculatedPercentage}%</span>
          )}
        </div>
      )}
      
      {/* Progress Bar */}
      <div className="progress-bar__track">
        <div 
          className="progress-bar__fill"
          style={{ width: `${Math.min(calculatedPercentage, 100)}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
